<template>
	<div class="_invite-employee _modal bg-white" data-tour-id="add-employee-form">
		<div
			class="
				_modal__content
				md-down:px-4
				px-12
				py-6
				flex flex-col
				items-center
				justify-center
			"
		>
			<div>
				<img
					src="@/assets/images/illustrations/record.png"
					alt="Luca Education"
					title="Luca Education"
					height="150"
					width="150"
				/>
			</div>
			<div
				class="
					_modal__content__title
					text-neutral-700
					font-semibold
					text-2xl
					mt-5
				"
			>
				{{
					invitedValue
						? 'Thêm tài khoản mới thành công'
						: 'Thêm tài khoản mới'
				}}
			</div>
			<div class="text-center text-neutral-500 mt-2">
				{{
					invitedValue
						? `Luca đã tạo tài khoản mới cho cơ sở của bạn. Lời mời liên kết đã được gửi tới email của người sử dụng tài khoản này.`
						: `Bạn hãy điền tên hiển thị và chọn vài trò cho tài khoản mới này
                        nhé. Luca mặc định gửi email liên kết tới người dùng tài khoản
                        này, bạn hãy điền email của người sử dụng nhé`
				}}
			</div>
			<div class="w-full mt-5">
				<div class="input-group flex items-center">
					<div
						class="
							input-group__label
							text-neutral-500
							font-normal
							w-2/5
						"
					>
						Họ và Tên
					</div>
					<input
						type="text"
						placeholder="Phụ huynh xem được thông tin này"
						v-if="!invitedValue"
						v-model="staff.full_name"
						:class="error['full_name'] ? 'input--error' : ''"
					/>
					<div
						class="font-bold text-neutral-500 text-right w-full"
						v-else
					>
						{{ staff.full_name }}
					</div>
				</div>
				<div
					class="input-group flex items-center"
					v-if="error['full_name']"
				>
					<div class="w-2/5"></div>
					<div class="mt-4 w-full">
						<div class="error text-sienna-600 text-sm w-full">
							{{ error['full_name'] }}
						</div>
					</div>
				</div>
				<div class="input-group flex items-center mt-5">
					<div
						class="
							input-group__label
							text-neutral-500
							font-normal
							w-2/5
						"
					>
						Tên hiển thị
					</div>
					<input
						type="text"
						placeholder="Nội bộ trung tâm xem được thông tin này"
						v-if="!invitedValue"
						v-model="staff.name"
						:class="error['name'] ? 'input--error' : ''"
					/>
					<div
						class="font-bold text-neutral-500 text-right w-full"
						v-else
					>
						{{ staff.name }}
					</div>
				</div>
				<div class="input-group flex items-center" v-if="error['name']">
					<div class="w-2/5"></div>
					<div class="mt-4 w-full">
						<div class="error text-sienna-600 text-sm w-full">
							{{ error['name'] }}
						</div>
					</div>
				</div>
				<div
					class="input-group flex items-center mt-5"
					v-if="!invitedValue"
				>
					<div
						class="
							input-group__label
							text-neutral-500
							font-normal
							w-2/5
						"
					>
						Chức vụ
					</div>
					<div class="w-full">
						<select
							class="
								block								
								pr-10
								py-2
								text-base
								border-gray-300
								focus:outline-none
								focus:ring-indigo-500
								focus:border-indigo-500
								sm:text-sm
								rounded-md
								input
								w-full
							"
							v-model="staff.role"
						>
							<option value="org_admin">Quản lý cơ sở</option>
							<option value="admin">Trưởng chuyên môn</option>
							<option value="teacher">{{ $filters.terminology('teacher') }}</option>
							<option value="accountant">Kế toán</option>
						</select>
					</div>
				</div>
				<div
					class="mt-5 flex flex-nowrap items-center"
					v-if="!invitedValue"
				>
					<Checkbox v-model:value="staff.send_invitation" />
					<div class="ml-2 text-sm text-neutral-700">
						Tự động gửi lời mời liên kết tới email của người sử dụng
					</div>
				</div>
				<div
					class="input-group flex items-center mt-5"
					v-if="!(invitedValue && !staff.send_invitation)"
				>
					<div
						class="
							input-group__label
							text-neutral-500
							font-normal
							w-2/5
						"
					>
						Email
					</div>
					<input
						type="text"
						placeholder="Email của người dùng tài khoản này"
						:disabled="staff.send_invitation && invitedValue"
						v-model="staff.email"
						:class="error['email'] ? 'input--error' : ''"
					/>
				</div>
				<div
					class="input-group flex items-center"
					v-if="error['email']"
				>
					<div class="w-2/5"></div>
					<div class="mt-4 w-full">
						<div class="error text-sienna-600 text-sm w-full">
							{{ error['email'] }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div
			class="
				_modal__footer
				px-12
				py-6
				bg-neutral-50
				flex flex-nowrap
				items-center
				md-down:flex-col-reverse
			"
		>
			<button
				type="button"
				class="
					button-p
					text-center
					mr-3
					bg-none
					shadow-none
					text-neutral-500
					hover:text-neutral-700
				"
				@click="$emit('close')"
			>
				{{ invitedValue ? 'Đóng' : 'Thoát' }}
			</button>
			<button
				type="button"
				class="button-p text-center whitespace-nowrap"
				v-if="!(invitedValue && staff.send_invitation)"
				@click="submit"
				:disabled="inProgress"
			>
				{{
					invitedValue
						? 'Gửi lời mời liên kết tới người dùng'
						: 'Thêm vào hệ thống và gửi lời mời'
				}}
			</button>
		</div>
	</div>
</template>

<script>
import { Options, Vue } from 'vue-class-component';
import Checkbox from '@/components/elements/checkbox/Checkbox.vue';
import { PropSync, Watch } from 'vue-property-decorator';

@Options({
	name: 'InviteEmployee',
	components: { Checkbox },
})
export default class InviteEmployee extends Vue {
	//----------------------- 🤍 Props 🤍 -----------------------//
	@PropSync('invited', { default: false, type: Boolean })
	invitedValue;

	@PropSync('inProgress', { default: false, type: Boolean })
	inProgress;

	@PropSync('error-prop', { type: Object })
	errorProp;

	//----------------------- 🤍 Data 🤍 -----------------------//

	staff = {
		email: '',
		full_name: '',
		name: '',
		phone_number: '',
		role: 'teacher',
		state: 'active',
		send_invitation: true,
	};

	error = {
		name: '',
		full_name: '',
		email: '',
		status: false,
	};

	@Watch('errorProp', { deep: true })
	onErrorChange(value) {
		this.error = value;
	}

	//----------------------- 🤍 Methods 🤍 -----------------------//
	submit() {
		this.error = {
			name: '',
			full_name: '',
			email: '',
			status: false,
		};
		if (this.staff.name?.length <= 0) {
			this.error['name'] = 'Tên hiển thị không được bỏ trống';
			this.error.status = true;
		}
		if (this.staff.full_name?.length <= 0) {
			this.error['full_name'] = 'Tên không được bỏ trống';
			this.error.status = true;
		}
		if (this.staff.email?.length <= 0) {
			this.error['email'] = 'Email không được bỏ trống';
			this.error.status = true;
		}
		if (this.error.status) {
			setTimeout(() => {
				this.error = {
					name: '',
					full_name: '',
					email: '',
					status: false,
				};
			}, 3000);
			return;
		}
		this.$emit('submit', this.staff);
	}
}
</script>
